export default "__VITE_ASSET__D304tE0i__"